import "@vintecc/components/style.css";
import { createRoot } from "react-dom/client";
import { IconPack, library } from "@fortawesome/fontawesome-svg-core";
import { fal } from "@vintecc/pro-light-svg-icons";
import "./index.css";
import { StrictMode } from "react";
import App from "./App";
import { preloadInitialCulture } from "./services/culture/bootstrap";

// TODO: only add the necessary icons
library.add(fal as IconPack);

const bootstrap = async () => {
  const initialCulture = await preloadInitialCulture();

  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App initialCulture={initialCulture} />
    </StrictMode>,
  );
};

void bootstrap();
